import styled from 'styled-components';

export const BannerRootContainer = styled.div`
    text-align: center;
    font-size: 12px;

    .conteneur {
        margin-top: 5px;
        margin-bottom: 5px;
    }

    @media screen and (max-width: ${props => props.theme.large}) {
        height: auto;
    }
`;



// WEBPACK FOOTER //
// ./src/components/banner/BannerRootStyle.js